import { render } from "./TotalSalesChart.vue?vue&type=template&id=7f48f6d0&ts=true"
import script from "./TotalSalesChart.vue?vue&type=script&lang=ts"
export * from "./TotalSalesChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__